import { useEffect, useState } from 'react';

/** Assina uma media query e re-renderiza quando ela muda. SPA (sem SSR), então lê já no init. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Desktop = breakpoint do DESIGN.md (>=1024px). Abaixo disso, mobile (bottom sheet, bottom nav). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)');
}
